// extracted by mini-css-extract-plugin
export default {"BreakpointFromLarge":"(min-width: 960px)","wrapper":"MainColumn_wrapper__FkNxa"};